<template>
  <Component
     :is="require(`@/components/icons/tag/${name}.svg`)"
     :x="x"
     :y="y"
     :fill="fill"
     v-bind="$attrs"
     @v-on="$listeners"
  />
</template>

<script>
const tagNamesMapping = {
  'tag_work_icon': 'icon-work',
  'tag_party_icon': 'icon-party',
  'tag_restaurant_icon': 'icon-restaurant',
  'tag_shopping_icon': 'icon-shopping',
  'tag_play_icon': 'icon-play',
  'tag_wellness_icon': 'icon-wellness',
  'tag_gym_icon': 'icon-gym',
  'tag_festival_icon': 'icon-party',
  'tag_picture_icon': 'icon-vacation',
  'tag_free_ride_icon': 'icon-free-ride',
  'tag_sleep_icon': 'icon-sleep',
  'tag_home_icon': 'icon-home',
  'tag_family_icon': 'icon-family',
  'tag_airport_icon': 'icon-vacation',
  'tag_l17_icon': 'icon-l17',
  'tag_work_briefcase_1_icon': 'icon-work-briefcase-1',
  'tag_weights_icon': 'icon-weights',
  'tag_sportwatch_icon': 'icon-sportwatch',
  'tag_shopping_basket_icon': 'icon-shopping-basket',
  'tag_vacation_icon': 'icon-vacation',
  'tag_transportation_water_icon': 'icon-transportation-water',
  'tag_transportation_railway_icon': 'icon-transportation-railway',
  'tag_transportation_bus_icon': 'icon-transportation-bus',
  'tag_transportation_taxi_icon': 'icon-transportation-taxi',
  'tag_road_icon': 'icon-road',
  'tag_education_icon': 'icon-education',
  'tag_visit_doorbell_icon': 'icon-visit-doorbell',
  'tag_car_service_icon': 'icon-car-service',
  'tag_health_pill_icon': 'icon-health-pill',
  'tag_health_heart_rate_icon': 'icon-health-heart-rate',
  'tag_bible_icon': 'icon-bible',
  'tag_person_icon': 'icon-person',
  'tag_car': 'icon-car',
  'tag_connected_car': 'icon-connected-car',
  'tag_fuel_tank': 'icon-fuel-tank',
  'tag_marker': 'icon-marker',
  'tag_people': 'icon-people',
  'tag_plus': 'icon-plus',
  'tag_category': 'icon-category',
  'tag_rule': 'icon-rule',
  'tag_default_icon': 'icon-default',
  'tag_danger_icon': 'icon-danger',
  'tag_notification': 'icon-notification',
  'tag_list': 'icon-list'
};

export default {
  name: 'TagIcon',

  // Transparent wrapper component
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,

  props: {
    tag: {
      type: String,
      required: true,
    },
    fill: {
      type: String,
      required: false
    },
    x: {
      type: Number,
      required: false,
      default: 12
    },
    y: {
      type: Number,
      required: false,
      default: 12
    }
  },

  computed: {
    name: function () {
      return tagNamesMapping[this.tag] || this.tag;
    }
  }
}
</script>

<style>
 </style>